module.exports = __webpack_public_path__ + "static/media/7.9784a859.JPG";